import { Button, CheckYesIcon, Flex, Text } from "@minervaproject/fds";

function PollConfirmationTextAndEditButton({
  handleEdit,
  isMobile,
}: {
  handleEdit: () => void;
  isMobile: boolean;
}) {
  const content = (
    <>
      <Flex none className="items-center">
        <CheckYesIcon size="lg" />
        <Text kind="body-s" color="blackTint20" bold ml={1}>
          Response submitted
        </Text>
      </Flex>
      {isMobile ? (
        <Button kind="text" onClick={handleEdit} data-testid="edit-poll-response-button" mt={3}>
          Edit Response
        </Button>
      ) : (
        <div className="pb4">
          <Button
            kind="secondary"
            onClick={handleEdit}
            data-testid="edit-poll-response-button"
            className="flex-none"
            mt={3}
          >
            Edit
          </Button>
        </div>
      )}
    </>
  );
  return isMobile ? <Flex className="flex-column items-center">{content}</Flex> : content;
}

export { PollConfirmationTextAndEditButton };
